// extracted by mini-css-extract-plugin
export var fadeIn = "_mw-1";
export var modalContent = "_mw-3";
export var overlay = "_mw-0";
export var popoverContent = "_mw-2";
export var results = "_mw-5";
export var searchInputWrapper = "_mw-4";